<template>
  <div class="configScreen" v-loading="allLoad">
    <div class="configMain">
      <div class="leftScreen">
        <div class="checkCharts">
          <el-select v-model="chart.type" placeholder="图表类型" :popper-append-to-body="false">
            <el-option v-for="item in chart.typeList" :label="item.label" :value="item.value">
              <div class="selOption">
                <div class="opIcon">
                  <svg viewBox="0 0 1024 1024" version="1.1" v-html="item.path"></svg>
                </div>
                <span>{{ item.label }}</span>
              </div>
            </el-option>
          </el-select>
        </div>
        <div class="leftCount">
          <el-scrollbar :native="false">
            <div class="chartUl" v-if="chart.type === 0">
              <el-popover :ref="'popover_' + item.type" popper-class="configScreen_pop_chart_chil" placement="right" :close-delay="50" :open-delay="100" trigger="click" v-for="item in chartAll.chart">
                <div class="chart_d" slot="reference">
                  <div class="drageDiv"></div>
                  <!-- <div class="imgDiv">
                    <img :src="chartsimgUrl +`${item.icon}`">
                  </div> -->
                  <span>{{ item.name }}</span>
                </div>
                <div class="chart_chil">
                  <div class="chart_d" v-for="i in item.chil" draggable @dragstart="getDrag(0, $event, item, i)">
                    <div class="drageDiv"></div>
                    <img :src="chartsimgUrl + `${i.ordImg}`" ondragstart="return false">
                    <span>{{ i.name }}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <div class="chartUl" v-if="chart.type === 1">
              <el-popover :ref="'popover_' + item.type" popper-class="configScreen_pop_chart_chil" placement="right" :close-delay="50" :open-delay="100" trigger="click" v-for="item in chartAll.viewDp">
                <div class="chart_d" slot="reference">
                  <div class="drageDiv"></div>
                  <!-- <div class="imgDiv">
                    <img :src="chartsimgUrl+`${item.icon}`">
                  </div> -->
                  <span>{{ item.name }}</span>
                </div>
                <div class="chart_chil">
                  <div class="chart_d" v-for="i in item.chil" draggable @dragstart="getDrag(0, $event, item, i)">
                    <div class="drageDiv"></div>
                    <img :src="i.refreshTime" @error="imgError($event, 0)" ondragstart="return false">
                    <span>{{ i.dataViewName }}</span>
                  </div>
                </div>
              </el-popover>
            </div>
            <div class="chartUl" v-if="chart.type === 2">
              <el-popover :ref="'popover_' + item.type" popper-class="configScreen_pop_chart_chil" placement="right" :close-delay="50" :open-delay="100" trigger="click" v-for="item in chartAll.elem">
                <div class="chart_d" slot="reference">
                  <div class="drageDiv"></div>
                  <!-- <div class="imgDiv">
                    <img :src="item.icon">
                  </div> -->
                  <span>{{ item.name }}</span>
                </div>
                <div class="chart_chil">
                  <div class="chart_d" v-for="i in item.chil" draggable @dragstart="getDrag(0, $event, item, i)">
                    <div class="drageDiv"></div>
                    <img :src="`${configImgUrl()}${i.ordImg}`" @error="errorImg(i.ordImg)" ondragstart="return false">
                    <span>{{ i.name }}</span>
                  </div>
                </div>
              </el-popover>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="centCanvas">
        <!-- 大屏区域 -->
        <div class="FCanvas" @dragover="getNoEvent($event)" @contextmenu="getNoEvent($event)">
          <!-- x轴线 -->
          <div class="rulerX">
            <div v-for="(item, index) in ruler.x" :class="{ bigRul: index % 5 === 0 }"></div>
          </div>
          <!-- y轴线 -->
          <div class="rulerY">
            <div v-for="(item, index) in ruler.y" :class="{ bigRul: index % 5 === 0 }"></div>
          </div>
          <!-- 配置大屏区域 -->
          <div id="configScreen_FCanvas_body" v-loading="FCanvas.load" element-loading-background="rgba(28, 44, 76, 0.72)">
            <el-scrollbar ref="configScreenScrollbar" class="canvasScrollbar" :native="false">
              <div class="FCanvas_Page drag_borChart_xy screen_page_chart" id="configScreen_FCanvas" @drop="getDrag(1, $event)" @mousedown.stop="getNoCheckList" v-show="canvas.show" :style="{ height: vuex.pageSize.height + 'px', width: vuex.pageSize.width + 'px' }">
                <backChart :back="nowChart.pageParam.back"></backChart>
                <VueDragResize v-for="(item, index) in vuex.chartList" class="FCharsDrog" :key="item.id" @dragging="getDragResize(arguments, item, index)" @resizing="getDragResize(arguments, item, index)" @dragstop="dragBoxStop(1)" @clicked.stop="getDragClick(item)" @resizestop="getDragOver(arguments, item)" :preventActiveBehavior="true" :z="item.trans.z" :isActive="item.active" :isDraggable="!item.trans.isNoDrag" :minw="item.trans.minWidth" :minh="item.trans.minHeight" :w="parseFloat(item.trans.width)" :h="parseFloat(item.trans.height)" :x="parseFloat(item.trans.x)" :y="parseFloat(item.trans.y)" :parentLimitation="true">
                  <charts :option="item" :key="item.id"></charts>
                </VueDragResize>
                <!-- 对齐的虚线 -->
                <div v-show="canvas.chartBorder" :style="{ top: trans.y + 'px' }" class="chart-barder chart-xy-barder-top">
                </div>
                <div v-show="canvas.chartBorder" :style="{ top: trans.y + trans.height + 'px' }" class="chart-barder chart-xy-barder-bottom"></div>
                <div v-show="canvas.chartBorder" :style="{ left: trans.x + 'px' }" class="chart-barder chart-xy-barder-left">
                </div>
                <div v-show="canvas.chartBorder" :style="{ left: trans.x + trans.width + 'px' }" class="chart-barder chart-xy-barder-right"></div>
              </div>
            </el-scrollbar>
          </div>
        </div>
        <!-- 滑块 -->
        <div class="centCanvas_block">
          <el-slider v-model="slider.value" @input="getCanvasResize" :step="1" @change="getCanvasResize"></el-slider>
        </div>
      </div>
      <div class="rightCanvas">
        <div class="tbld">
          <FBtn type="2" @click="echartsLinkage(0)">图表联动</FBtn>
        </div>
        <div class="ConfigFrom">
          <div class="noSelect tilConfig">
            <span :class="{ tilConfAdd: rigConfig.type === 0 }" @click="getConfigType(0)">大屏配置</span>
            <span :class="{ tilConfAdd: rigConfig.type === 1 }" @click="getConfigType(1)">组件配置</span>
          </div>
          <div class="countConfig ">
            <div class="config_div config_div_left" v-if="rigConfig.type === 0">
              <div class="conLef_top">
                <el-scrollbar :native="false">
                  <div class="configFlot">
                    <div class="comDP_config">
                      <div class="config_comTop">
                        <span class="btSpan">大屏名称</span>
                        <el-input v-model="rigConfig.dpName" placeholder="请输入大屏名称"></el-input>
                      </div>
                    </div>
                  </div>
                  <div class="folt_chil_div">
                    <div class="div_til">页面配置</div>
                    <comScreenDP class="com_screen_Flot"></comScreenDP>
                  </div>
                  <div class="folt_chil_div">
                    <div class="div_til">背景配置</div>
                    <backConfig class="com_screen_Flot"></backConfig>
                  </div>
                  <div class="folt_chil_div">
                    <div class="div_til">定时任务</div>
                    <screenTimingTask class="com_screen_Flot"></screenTimingTask>
                  </div>
                  <div class="folt_chil_div">
                    <div class="div_til">图层</div>
                    <dragLayer ref="dragLayerRef" :show="dpTC.show" :id="clickIdDrag" @update="dpTC.show = false" @noClick="getDragClick"></dragLayer>
                  </div>
                </el-scrollbar>
              </div>
            </div>
            <div class="config_div scrollBar_xy config_div_rig" v-if="rigConfig.type === 1">
              <div class="config_div_rig_div">
                <FFnewBox name="基本配置" v-if="chartVuex.id" type="screen">
                  <basicConfig class="com_screen_Flot" type="screen"></basicConfig>
                </FFnewBox>
                <FFoldBox v-if="nowChart.config.comConfig" name="公共配置" type="screen">
                  <comChart class="com_screen_Flot" type="screen"></comChart>
                </FFoldBox>
                <FFoldBox v-if="nowChart.config.borderConfig" name="边框配置" type="screen">
                  <borderConfig class="com_screen_Flot" type="screen"></borderConfig>
                </FFoldBox>
                <FFoldBox :name="item.name" v-for="item in nowChart.comPonent.component" v-if="item.show" type="screen">
                  <component :is="item.component" type="screen" class="com_screen_Flot"></component>
                </FFoldBox>
                <FFoldBox v-if="nowChart.config.JSONConfig" name="数据接入" type="screen">
                  <comJSONData class="com_screen_Flot" type="screen"></comJSONData>
                  <div class="wdl_ri_div" v-if="nowChart.config.wdConfig">
                    <div v-for="item in chartVuex.setting.wdList" @click="getWDDialog(0, item)">
                      {{ item.name }}
                    </div>
                  </div>
                  <div class="wdl_ri_div" v-if="nowChart.config.dlConfig">
                    <div v-for="item in chartVuex.setting.dlList" @click="getDLDialog(0, item)">
                      {{ item.name }}
                    </div>
                  </div>
                </FFoldBox>
                <FFoldBox v-if="nowChart.config.JSONConfig" name="定时任务" type="screen">
                  <chartsTimingTask class="com_screen_Flot"></chartsTimingTask>
                </FFoldBox>
              </div>
            </div>
            <div class="save_div">
              <FBtn title="保存" type="19" @click="getSave"></FBtn>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--维度配置-->
    <FDialog class="screen_wd_dialog" :dialog="dpWD.show" :title="'维度 -' + ' ' + dpWD.title" @close="getWDDialog(1)" moveWidth="630px">
      <div class="dialog_count">
        <component :is="nowChart.comPonent.wdComponent" type="screen"></component>
      </div>
    </FDialog>
    <!--度量配置-->
    <FDialog class="screen_dl_dialog" :dialog="dpDL.show" :title="'度量 -' + ' ' + dpDL.title" @close="getDLDialog(1)" moveWidth="630px">
      <div class="dialog_count">
        <component :is="nowChart.comPonent.dlComponent" type="screen" :index="dpDL.index"></component>
      </div>
    </FDialog>
    <!--图层-->
    <FDialog class="tuCeng" :dialog="Linkage.dialog" :title="Linkage.title" moveWidth="878px" @close="echartsLinkage(1)">
      <div class="linkage">
        <div class="left">
          <div class="tit">
            参数传达
            <span @click="echartsChuanda(0)"><i class="el-icon-search"></i>查询</span>
          </div>
          <div class="content">
            <div class="echarts">
              <ul>
                <li :key="item.id" v-for="(item, index) in vuex.chartList" @click="convey(item, index)" :class="isActive1 == index ? 'whiteBg' : ''">
                  <span>{{ item.aliasName }}</span>
                </li>
              </ul>
            </div>
            <div class="fields">
              <ul>
                <li v-for="(item, index) in conveyFields" :key="item.index" @click="conveyField(item, index)" :class="isActive2 == index ? 'whiteBg' : ''">
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="tit">
            参数接收
            <span @click="echartsChuanda2(0)"><i class="el-icon-search"></i>查询</span>
          </div>
          <div class="content">
            <div class="echarts">
              <ul>
                <li :key="item.id" v-for="(item, index) in vuex.chartList" @click="receive(item, index)" :class="isActive3 == index ? 'whiteBg' : ''">
                  <span>{{ item.aliasName }}</span>
                </li>
              </ul>
            </div>
            <div class="fields">
              <ul>
                <li v-for="(item, index) in receiveFields" :key="item.index" @click="receiveField(item, index)" :class="isActive4 == index ? 'whiteBg' : ''">
                  <span>{{ item }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="bottom">
          <div class="bottom_tit">
            <div class="leftList">
              <div class="tit">参数：</div>
            </div>
            <div class="rightList">
              <div class="tit">对应：</div>
            </div>
          </div>
          <div v-for='(it, idx) in clearfieldArr' :key='idx' class="judge">
            <input type="text" placeholder="参数传达表" maxlength="15" v-model="it.clearText">
            <input type="text" placeholder="参数传达字段" maxlength="15" v-model="it.clearText2">
            <input type="text" placeholder="参数接收表" class="minInp" maxlength="15" v-model="it.clearText3">
            <input type="text" placeholder="参数传达字段" class="minInp" maxlength="15" v-model="it.clearText4">
            <div class="circleBtn">
              <div class="circleAdd" @click="addClearInput()">+</div>
              <div class="circleDel" @click="delClearInput(idx)">-</div>
            </div>
          </div>
          <div class="btn">
            <el-button @click="onLinkage()">保存</el-button>
            <el-button @click="offLinkage()">取消</el-button>
          </div>
        </div>
      </div>
    </FDialog>
    <FDialog class="tuCeng" :dialog="chuanda.dialog" :title="chuanda.title" moveWidth="878px" @close="echartsChuanda(1)">
      <div class="chuanda">
        <div class="left">
          <div class="tit">查询条件
            <el-button type="text" @click="open"><img src="../../../../../assets/common/image/add.png"></el-button>
          </div>
          <ul>
            <li v-for="(item,index) in DelList" :key="index">{{item}}<img @click="delField(item,index)" src="../../../../../assets/common/image/del.png"></li>
          </ul>
        </div>
        <div class="center" id="Data">
          <div class="tit">关联图表及字段</div>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText1">
          </el-input>
          <el-tree class="filter-tree" @node-click="handleNodeClick" :data="data" :props="defaultProps1" default-expand-all :filter-node-method="filterNode1" ref="tree1">
          </el-tree>
        </div>
        <div class="center" id="newData">
          <div class="tit">关联图表及字段</div>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText2">
          </el-input>
          <el-tree class="filter-tree" @node-click="handleNodeClick" :data="newData" :props="defaultProps2" default-expand-all :filter-node-method="filterNode2" ref="tree2">
          </el-tree>
        </div>
        <div class="right">
          展示类型：<el-select v-model="value1" clearable placeholder="请选择">
            <el-option v-for="item in options1" :key="item.label" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
          图表名称：<el-select v-model="value2" clearable placeholder="请选择">
            <el-option :key="index" v-for="(item, index) in vuex.chartList" :label="item.aliasName" :value="item.id">
            </el-option>
          </el-select>
          字段名称：
          <el-input class="el-select" v-model="value3"></el-input>
        </div>
        <div class="bottom">
          <el-button type="info" @click="cancelCheck()">取消</el-button>
          <el-button type="primary" @click="saveCheck()">确定</el-button>
        </div>
      </div>
    </FDialog>
    <FDialog class="tuCeng" :dialog="jieshou.dialog" :title="jieshou.title" moveWidth="878px" @close="echartsChuanda2(1)">
      <div class="chuanda">
        <div class="left">
          <div class="tit">查询条件
            <el-button type="text" @click="open"><img src="../../../../../assets/common/image/add.png"></el-button>
          </div>
          <ul>
            <li v-for="(item,index) in DelList" :key="index">{{item}}<img @click="delField(item,index)" src="../../../../../assets/common/image/del.png"></li>
          </ul>
        </div>
        <div class="center" id="Data">
          <div class="tit">关联图表及字段</div>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText1">
          </el-input>
          <el-tree class="filter-tree" @node-click="handleNodeClick2" :data="data" :props="defaultProps1" default-expand-all :filter-node-method="filterNode1" ref="tree1">
          </el-tree>
        </div>
        <div class="center" id="newData">
          <div class="tit">关联图表及字段</div>
          <el-input placeholder="输入关键字进行过滤" v-model="filterText2">
          </el-input>
          <el-tree class="filter-tree" @node-click="handleNodeClick2" :data="newData" :props="defaultProps2" default-expand-all :filter-node-method="filterNode2" ref="tree2">
          </el-tree>
        </div>
        <div class="right">
          展示类型：<el-select v-model="value4" clearable placeholder="请选择">
            <el-option v-for="item in options1" :key="item.label" :label="item.label" :value="item.label">
            </el-option>
          </el-select>
          图表名称：<el-select v-model="value5" clearable placeholder="请选择">
            <el-option :key="index" v-for="(item, index) in vuex.chartList" :label="item.aliasName" :value="item.id">
            </el-option>
          </el-select>
          字段名称：
          <el-input class="el-select" v-model="value6"></el-input>
        </div>
        <div class="bottom">
          <el-button type="info" @click="cancelCheck()">取消</el-button>
          <el-button type="primary" @click="saveCheck2()">确定</el-button>
        </div>
      </div>
    </FDialog>
  </div>
</template>

<script>
/**
 @author xiaoye
 @date 2020/4/10 3:00 下午
 */
import modules from '../../../charts/script/modules'
import VueDragResize from 'vue-drag-resize';
import comChart from '../../../charts/comConfig/comChart'
import comScreenDP from '../../comPont/comScreenDP'
import comJSONData from '../../comPont/comJSONData'
import optionChart from '../../script/option'
import dragLayer from '../../comPont/dragLayer/dragLayer'
import basicConfig from '../../comPont/basicConfig/basicConfig'
import borderConfig from '../../comPont/borderConfig/borderConfig'
import backConfig from '../../comPont/backConfig/backConfig'
import charts from '../../charts/charts'
import backChart from '../../charts/backChart'
import setConfigAll from '@/assets/js/config'
import { getViewDpData, Guuid } from '@/assets/js/basis'
import chartsTimingTask from '../../comPont/chartsTimingTask/chartsTimingTask'
import screenTimingTask from '../../comPont/screenTimingTask/screenTimingTask'
// import Mock from 'mockjs'
import $ from "jquery"
import {
  SaveScreenPage,
  GetScreenPageNameVerify,
  GetScreenPageIndexByID,
  GetScreenByGroupID,
  GetScreenDataViews,
  UploadPreviewPictureAsync,
  CreateLinkAge
} from '@/assets/axios/createScreen/configScreen'

export default {
  name: 'configScreen',
  components: {
    VueDragResize,
    comScreenDP,
    comJSONData,
    comChart,
    dragLayer,
    basicConfig,
    charts,
    backChart,
    borderConfig,
    backConfig,
    chartsTimingTask,
    screenTimingTask,
  },
  props: {},
  data() {
    return {
      DelList: [
      ],
      value1: '',
      value2: '',
      value3: '',
      value5: '',
      value4: '',
      value6: '',
      options1: [{
        value: '选项1',
        label: '柱状图'
      }, {
        value: '选项2',
        label: '折线图'
      }, {
        value: '选项3',
        label: '饼状图'
      }, {
        value: '选项4',
        label: '散点图'
      }, {
        value: '选项5',
        label: '雷达图'
      }, {
        value: '选项6',
        label: '仪表盘'
      }, {
        value: '选项7',
        label: '漏斗图'
      }, {
        value: '选项8',
        label: '指标'
      }, {
        value: '选项9',
        label: '列表'
      }, {
        value: '选项10',
        label: '地图'
      }, {
        value: '选项11',
        label: '点地图'
      }, {
        value: '选项12',
        label: '线地图'
      }, {
        value: '选项13',
        label: '3D地图'
      }, {
        value: '选项14',
        label: '3D地球'
      }, {
        value: '选项15',
        label: '线路图'
      }],
      options3: [],
      filterText1: '',
      filterText2: '',
      data: [],
      newData: [],
      defaultProps1: {
        children: 'children',
        label: 'label'
      },
      defaultProps2: {
        children: 'children',
        label: 'label'
      },
      onOff: false,
      save: false,
      receiveFields: [],
      conveyFields: [],
      clearfieldArr: [
        {
          clearText: '',
          clearText2: '',
          clearText3: '',
          clearText4: '',
        }
      ],
      isOutIn: 0,
      outLinkText: "",//外部网址链接
      rotationID: "",//轮播大屏id
      rotationTime: 0,//轮播时间
      checkedVal1: 0,//大屏轮播是否开启
      //判断是否操作 0 没有操作 1 操作了
      count: 0,
      //整体换成
      allLoad: false,
      //当前的页面类型 修改还是新增
      type: '',
      //id
      viewScree: {
        type: '新增',
        //模版组的ID
        modeId: '',
        //大屏页面的ID
        viewDPId: '',
        //保存的预览图
        pageImg: '',
      },
      //修改时 接口数据
      jkData: {},
      //图表
      chart: {
        type: 0,
        typeList: [
          {
            label: '基本图表', value: 0,
            path: '<path d="M468.576904 1023.991009c-258.766931 0-468.541897-209.542262-468.541897-468.045462 0-258.503199 209.774966-468.060975 468.541897-468.060975 12.162666 0 24.123656 0.884275 36.038105 1.799578v413.592708h429.726857c1.784065 16.56853 2.776935 35.634751 2.776935 52.668689 0 258.503199-209.774966 468.045462-468.541897 468.045462zM449.231439 141.406509c-216.880197 11.697258-389.282889 190.848368-389.282889 410.784746 0 227.47599 184.301627 411.917239 411.684535 411.917239 224.885217 0 407.356239-180.516307 411.296694-404.594818H449.231439V141.406509z"></path>\n' +
              '    <path d="M593.368343 465.408149H1039.539621c0-0.542976-0.046541-1.070439-0.046541-1.597902v-44.896372h-2.296013C1013.787037 184.053409 815.430084 0.620544 574.146986 0.620544c-12.085098 0-19.252384-1.054925-31.089264-0.139622V465.408149h50.310621z m0-411.637994c201.133888 10.859523 363.6389 166.724712 384.334049 365.14372H593.368343V53.770155z"></path>'
          },
          {
            label: '多维分析', value: 1,
            path: ' <path d="M960.4 961.3h-897v-897h897v897z m-85.2-810.9H150.5v724.7h724.7V150.4z"></path>\n' +
              '    <path d="M427.8 560.1V343c0-40.4 13.8-54.3 54.8-54.3 114.4-1.1 114.4-7.4 113.3 111.7-1.1 125 0 250.1-0.5 375.1 0 47.4-12.2 59.1-60.1 59.6-108.5 1.6-109.6 3.7-108-106.9 1.5-55.8 0.5-111.7 0.5-168.1zM666.1 646.8c0-46.8-0.5-93.6 0-139.9 0.5-34.1 14.9-48.9 48.9-49.5 23.4-0.5 46.8-0.5 70.2 0 34.1 1.1 48.4 15.4 48.4 50 0.5 93.6 0 186.7 0 280.4 0 31.4-16 47.4-47.4 47.9h-73.4c-31.4-0.5-46.8-17-46.8-48.4 0.1-47.4 0.7-93.7 0.1-140.5zM272.9 667c11.7 0 23.4-0.5 35.1 0 34.1 1.1 48.4 14.9 49.5 48.9 0.5 23.4 0 46.8 0 70.2 0 30.9-14.9 48.4-46.3 48.4-25.5 0.5-51.6 0.5-77.1 0-27.7-0.5-43.1-16-44.2-43.6-1.1-20.7-0.5-42 0-63.3 0-49.5 12.2-61.2 62.2-61.2 7 0.6 13.9 0.6 20.8 0.6z"></path>'
          },
          {
            label: '元素', value: 2,
            path: '<path d="M768 1024H523.2v-81.6c0-62.4-51.2-113.6-113.6-113.6-62.4 0-113.6 51.2-113.6 113.6V1024H51.2c-14.4 0-27.2-4.8-36.8-14.4V1008c-8-11.2-12.8-22.4-12.8-35.2V752h86.4c60.8-1.6 110.4-52.8 110.4-113.6s-48-112-110.4-113.6H3.2V224c0-14.4 4.8-27.2 14.4-36.8H16c11.2-8 22.4-12.8 35.2-12.8h225.6V147.2c1.6-40 17.6-76.8 44.8-104C350.4 16 387.2 1.6 425.6 1.6c40 1.6 76.8 17.6 104 44.8 27.2 28.8 41.6 65.6 41.6 104v22.4h198.4c14.4 0 27.2 4.8 36.8 14.4l1.6 1.6c8 11.2 12.8 22.4 12.8 35.2v256h52.8c41.6 0 81.6 17.6 110.4 46.4 27.2 28.8 41.6 67.2 40 107.2 0 84.8-67.2 152-152 152h-52.8v188.8c0 14.4-4.8 27.2-14.4 36.8l-1.6 1.6c-11.2 6.4-22.4 11.2-35.2 11.2z m-212.8-32H768c4.8 0 9.6-1.6 14.4-4.8 3.2-3.2 4.8-8 4.8-12.8V752h84.8c67.2 0 120-52.8 120-120 1.6-32-9.6-60.8-32-83.2-22.4-24-54.4-36.8-88-36.8h-84.8V224c0-4.8-1.6-9.6-4.8-14.4-3.2-3.2-8-4.8-12.8-4.8H539.2V152c0-30.4-11.2-59.2-32-81.6-20.8-22.4-49.6-35.2-81.6-35.2-30.4 0-59.2 11.2-81.6 32-22.4 20.8-35.2 49.6-35.2 81.6V208H51.2c-4.8 0-9.6 1.6-14.4 4.8-3.2 3.2-4.8 8-4.8 12.8v267.2h54.4c80 3.2 142.4 67.2 142.4 145.6 0 78.4-64 144-140.8 145.6H33.6v188.8c0 4.8 1.6 9.6 4.8 14.4 3.2 3.2 8 4.8 12.8 4.8h212.8v-49.6c0-80 65.6-145.6 145.6-145.6s145.6 65.6 145.6 145.6V992z"></path>'
          },
        ]
      },
      //图表
      chartAll: {
        chart: [],
        viewDp: [],
        elem: []
      },
      //画布
      FCanvas: {
        load: true,
      },
      //右侧配置
      rigConfig: {
        type: 0,
        dpName: '',
        collapseModal: [
          '基本配置',
          '公共配置',
        ],
      },
      //拖动数据传递
      dropVal: {
        name: '',
        type: '',
        id: '',
      },
      //canvas
      canvas: {
        show: false,
        //是否展示标注线
        chartBorder: false,
      },
      //维度弹框
      dpWD: {
        show: false,
        title: '',
        index: null,
      },
      //度量弹框
      dpDL: {
        show: false,
        title: '',
        index: null,
      },
      //图层
      dpTC: {
        show: true,
      },
      //刻度尺
      ruler: {
        x: 200,
        y: 200,
      },
      //滑块
      slider: {
        value: 67,
      },
      trans: {
        x: 0,
        y: 0,
        width: 0,
        height: 0,
      },
      // 图片地址
      chartsimgUrl: setConfigAll.chartsRequestUrl,
      //撤销还原数组
      listUndo: [],
      //当前
      undoNowIndex: 0,
      //操作过程中产生的数据
      updProcessList: [],
      saveJSONChart: '',
      //点击图表id
      clickIdDrag: '',
      Linkage: {
        dialog: false,
        title: '图表联动',
        type: 0,
      },
      chuanda: {
        dialog: false,
        title: '参数传达查询',
        type: 0,
      },
      jieshou: {
        dialog: false,
        title: '参数接收查询',
        type: 0,
      },
      isActive1: -1,
      isActive2: -1,
      isActive3: -1,
      isActive4: -1,
    }
  },
  methods: {
    saveCheck() {
      if (!this.value1 || !this.value2 || !this.value3) {
        this.getMsg('请完善查询条件！');
      } else {
        this.getMsg('保存成功！', 'success');
        this.chuanda.dialog = false;
        var a = this.clearfieldArr.length;
        this.clearfieldArr[a - 1].clearText = this.value2;
        this.clearfieldArr[a - 1].clearText2 = this.value3;
      }
    },
    saveCheck2() {
      if (!this.value4 || !this.value5 || !this.value6) {
        this.getMsg('请完善查询条件！');
      } else {
        this.getMsg('保存成功！', 'success');
        this.jieshou.dialog = false;
        var a = this.clearfieldArr.length;
        this.clearfieldArr[a - 1].clearText3 = this.value5;
        this.clearfieldArr[a - 1].clearText4 = this.value6;
      }
    },
    cancelCheck() {
      this.chuanda.dialog = false;
      this.data = []
    },
    delField(item, index) {
      this.DelList.splice(index, 1);
    },
    open() {
      this.$prompt('请输入条件字段', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '请输入条件字段'
      }).then(({ value }) => {
        this.$message({
          type: 'success',
          message: '条件字段添加成功'
        },
          this.DelList.push(value),
        );
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    xz() {
    },
    sz() {
    },
    filterNode1(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    filterNode2(value, newData) {
      if (!value) return true;
      return newData.label.indexOf(value) !== -1;
    },
    handleNodeClick(value, item, data) {
      if (item.childNodes.length == 0) {
        this.value1 = item.parent.data.type
        this.value2 = item.parent.data.label
        this.value3 = item.data.label
      } else {
        this.value1 = item.data.type
        this.value2 = item.data.label
        this.value3 = ''
      }
    },
    handleNodeClick2(value, item, data) {
      if (item.childNodes.length == 0) {
        this.value4 = item.parent.data.type
        this.value5 = item.parent.data.label
        this.value6 = item.data.label
      } else {
        this.value4 = item.data.type
        this.value5 = item.data.label
        this.value6 = ''
      }
    },
    convey(item, index) {
      this.isActive1 = index;
      this.isActive2 = -1;
      this.getDragClick(item)
      var a = this.clearfieldArr.length;
      this.clearfieldArr[a - 1].clearText = item.aliasName;
      this.clearfieldArr[a - 1].clearText2 = '';
      var wdList = item.saveOption.setting.wdList;
      var dlList = item.saveOption.setting.dlList;
      var wdFields = [];
      var dlFields = [];
      var conveyFields = []

      for (var wdSub = 0; wdSub < wdList.length; wdSub++) {
        var wdField = wdList[wdSub].name;
        wdFields.push(wdField)
      }
      for (var dlSub = 0; dlSub < dlList.length; dlSub++) {
        var dlField = dlList[dlSub].name;
        dlFields.push(dlField)
      }
      var conveyFields = wdFields.concat(dlFields);
      this.conveyFields = conveyFields;
    },
    conveyField(item, index) {
      this.isActive2 = index;
      var a = this.clearfieldArr.length;
      this.clearfieldArr[a - 1].clearText2 = item;
    },
    receive(item, index) {
      this.isActive3 = index;
      this.isActive4 = -1;
      this.getDragClick(item)
      var a = this.clearfieldArr.length;
      this.clearfieldArr[a - 1].clearText3 = item.aliasName;
      this.clearfieldArr[a - 1].clearText4 = '';
      var wdList = item.saveOption.setting.wdList;
      var dlList = item.saveOption.setting.dlList;
      var wdFields = [];
      var dlFields = [];
      var receiveFields = []

      for (var wdSub = 0; wdSub < wdList.length; wdSub++) {
        var wdField = wdList[wdSub].name;
        wdFields.push(wdField)
      }
      for (var dlSub = 0; dlSub < dlList.length; dlSub++) {
        var dlField = dlList[dlSub].name;
        dlFields.push(dlField)
      }
      var receiveFields = wdFields.concat(dlFields);
      this.receiveFields = receiveFields;
    },
    receiveField(item, index) {
      this.isActive4 = index;
      var a = this.clearfieldArr.length;
      this.clearfieldArr[a - 1].clearText4 = item;
    },
    async onLinkage() {
      let jkDataList = [];
      for (var i = 0; i < this.jkData.child.length; i++) {
        jkDataList.push(JSON.parse(this.jkData.child[i].requestJson))
      }
      let LinKageAttr = this.clearfieldArr;
      LinKageAttr = this.clearfieldArr.map(iterator => {
        return {
          SenderID: iterator.clearText,
          SenderField: iterator.clearText2,
          ReceiverID: iterator.clearText3,
          ReceiverField: iterator.clearText4,
          DataViewID: '',
        }
      })
      var idList1 = []
      var idList2 = []
      var viewList = []
      for (var i = 0; i < LinKageAttr.length; i++) {
        var data1 = jkDataList.filter(function (item) {
          return item.aliasName == LinKageAttr[i].SenderID;
        })
        idList1.push(data1[0].id)
        LinKageAttr[i].SenderID = idList1[i]

        var data2 = jkDataList.filter(function (item) {
          return item.aliasName == LinKageAttr[i].ReceiverID;
        })
        idList2.push(data2[0].id)
        LinKageAttr[i].ReceiverID = idList2[i]
        viewList.push(data2[0].viewDP.viewId)
        LinKageAttr[i].DataViewID = viewList[i]
      }
      await CreateLinkAge({
        screenID: this.viewScree.viewDPId,//大屏ID
        groupID: this.viewScree.modeId,// 组ID
        linKageAttr: LinKageAttr,
      }).then(res => {
        if (res.code === 200) {
          this.getMsg(res.message, 'success');
          this.Linkage.dialog = false;
        }
      }).catch(() => {

      });
    },
    offLinkage() {
      this.Linkage.dialog = false;
    },
    addClearInput() {
      for (let i in this.clearfieldArr[this.clearfieldArr.length - 1]) {
        if (!this.clearfieldArr[this.clearfieldArr.length - 1][i]) {
          this.getMsg('请先完善当前联动条件！');
          return;
        }
      }
      this.clearfieldArr.push({ clearText: '', clearText2: '', clearText3: '', clearText4: '' })
    },
    delClearInput(idx) {
      if (this.clearfieldArr.length == 1) {
        this.getMsg('当前联动条件不可删除！');
        return;
      }
      this.clearfieldArr.splice(idx, 1)
    },
    echartsLinkage(type) {
      if (type === 0) {
        this.Linkage.dialog = true;
      }
      else if (type === 1) {
        this.Linkage.dialog = false;
      }
    },
    echartsChuanda(type) {
      if (type === 0) {
        this.value1 = ''
        this.value2 = ''
        this.value3 = ''
        this.data = []
        this.DelList = []
        this.chuanda.dialog = true;
        for (var i = 0; i < this.vuex.chartList.length; i++) {
          var obj = {}
          obj.label = this.vuex.chartList[i].aliasName
          obj.type = this.vuex.chartList[i].name
          obj.id = this.vuex.chartList[i].id
          obj.children = []
          for (var j = 0; j < this.vuex.chartList[i].saveOption.setting.dlList.length; j++) {
            var a = {}
            a.label = this.vuex.chartList[i].saveOption.setting.dlList[j].name
            obj.children.push(a)
          }
          for (var k = 0; k < this.vuex.chartList[i].saveOption.setting.wdList.length; k++) {
            var b = {}
            b.label = this.vuex.chartList[i].saveOption.setting.wdList[k].name
            obj.children.push(b)
          }
          this.data.push(obj)
        }
      }
      else if (type === 1) {
        this.chuanda.dialog = false;
      }
    },
    echartsChuanda2(type) {
      if (type === 0) {
        this.value4 = ''
        this.value5 = ''
        this.value6 = ''
        this.data = []
        this.DelList = []
        this.jieshou.dialog = true;
        for (var i = 0; i < this.vuex.chartList.length; i++) {
          var obj = {}
          obj.label = this.vuex.chartList[i].aliasName
          obj.type = this.vuex.chartList[i].name
          obj.id = this.vuex.chartList[i].id
          obj.children = []
          for (var j = 0; j < this.vuex.chartList[i].saveOption.setting.dlList.length; j++) {
            var a = {}
            a.label = this.vuex.chartList[i].saveOption.setting.dlList[j].name
            obj.children.push(a)
          }
          for (var k = 0; k < this.vuex.chartList[i].saveOption.setting.wdList.length; k++) {
            var b = {}
            b.label = this.vuex.chartList[i].saveOption.setting.wdList[k].name
            obj.children.push(b)
          }
          this.data.push(obj)
        }
      }
      else if (type === 1) {
        this.jieshou.dialog = false;
      }
    },
    echartsJieshou(type) {
      if (type === 0) {
        this.jieshou.dialog = true;
      }
      else if (type === 1) {
        this.jieshou.dialog = false;
      }
    },
    resize() {
      this.getBodyCanvas();
      this.ruler = {
        x: parseInt($('.rulerX').width() / 10),
        y: parseInt($('.rulerY').height() / 10),
      }
    },
    async init() {//获取模版ID
      let modeId = await this.getSession('screen_module_xy');
      if (modeId) {
        this.viewScree.modeId = modeId;
      } else {
        this.getMsg('请求失败 请重新尝试');
        return this.getRouterPath('/stencilList');
      }
      let type = await this.getSession('screen_type_xy');
      if (type) {
        this.type = type;
      } else {
        this.getMsg('请求失败 请重新尝试');
        return this.getRouterPath('/stencilList');
      }
      await this.getChartsAll();
      //可刻度尺
      this.ruler = {
        x: parseInt($('.rulerX').width() / 10),
        y: parseInt($('.rulerY').height() / 10),
      };
      this.getBodyCanvas();
      this.getCanvasResize();
      await this.$store.dispatch('clearDesigner');
      this.FCanvas.load = true;
      if (this.type === 'upd') {
        let viewDpId = await this.getSession('screen_viewDp_xy');
        if (viewDpId) {
          this.viewScree.viewDPId = viewDpId;
          await this.getUpdAllData();
          await this.addRoute('upd');
        } else {
          this.getMsg('请求失败 请重新尝试');
          return this.getRouterPath('/stencilList');
        }
      } else if (this.type === 'add') {
        await this.addRoute('add');
      }
      this.count = 1;
    },
    //【新增】获取模版信息
    async addRoute(type) {
      await GetScreenByGroupID({
        groupID: this.viewScree.modeId
      }).then(res => {
        if (res.code === 200) {
          let data = res.data;
          if (type === 'add') {
            this.vuex.pageSize.width = data.sizeX;
            this.vuex.pageSize.height = data.sizeY;
            this.canvas.show = true;
          }
          if (data.child) {
            data.child.map((item) => {
              if (type === 'upd') {
                if (item.id === this.viewScree.viewDPId) {
                  return;
                }
              }
              this.vuex.groupDpList.push(item)
            })
          }
        }
      }).catch(() => {

      });
      setTimeout(() => {
        this.FCanvas.load = false;
      }, 400)
    },
    //【修改】获取所有数据
    async getUpdAllData() {
      this.jkData = {};
      await GetScreenPageIndexByID({
        screenID: this.viewScree.viewDPId
      }).then(async res => {
        if (res.code === 200) {
          let node = res.data;
          this.vuex.pageSize.width = node.sizeX || 0;
          this.vuex.pageSize.height = node.sizeY || 0;
          this.canvas.show = true;
          try {
            this.$nextTick(async () => {
              this.jkData = JSON.parse(JSON.stringify(node));
              this.rigConfig.dpName = node.screenPageName;
              let pageParam = JSON.parse(node.screenJson);
              let defaultVal = JSON.parse(JSON.stringify(this.$store.state.designer.defaultVal));
              this.nowChart.pageParam = JSON.parse(JSON.stringify(await this.getDGCopy(defaultVal.pageParam, pageParam)));
              let modu = modules;
              this.$store.dispatch('screenAllRender', { modu, node });
              // this.checkedVal1 = res.data.child[0].isRotation;
            })
          } catch (e) {

          }
        }
      });
    },
    // 获取所有多维分析数据
    async getViewDpValue() {
      this.chartAll.viewDp = [];
      await GetScreenDataViews().then(async res => {
        if (res.code === 200) {
          let data = res.data;
          let typeList = [];
          if (data.dataTable.length) {
            data.dataTable.map((item) => {
              if (item.chartType) {
                typeList.push(item.chartType)
              }
            })
          }
          let typeRepeatList = await this.listRepeat(typeList);

          typeRepeatList.map((item) => {
            let chart = modules[item];
            if (chart) {
              let chil = [];
              data.dataTable.map((i) => {
                if (i.chartType === item) {
                  if (!i.refreshTime) {
                    i.refreshTime = '';
                  }
                  chil.push(i)
                }
              });
              this.chartAll.viewDp.push({
                name: chart.name,
                type: item,
                icon: chart.iconImg,
                chil: chil
              })
            }
          });
        }
      })
    },
    //查询所有图表
    async getChartsAll() { //标签
      let chartList = [];
      let elemList = [];
      for (let i in modules) {
        if (modules[i].class === 'chart') {
          chartList.push({
            name: modules[i].name,
            icon: modules[i].iconImg,
            type: modules[i].type,
            chil: modules[i].chilCharts,
            sort: modules[i].sort || 999
          })
        } else if (modules[i].class === 'elem') {
          elemList.push({
            name: modules[i].name,
            icon: modules[i].iconImg,
            type: modules[i].type,
            chil: modules[i].chilCharts,
            sort: modules[i].sort || 999
          })
        }
      }
      chartList.sort((obj1, obj2) => {
        let val1 = obj1['sort'];
        let val2 = obj2['sort'];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
        }
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      }
      );
      elemList.sort((obj1, obj2) => {
        let val1 = obj1['sort'];
        let val2 = obj2['sort'];
        if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
          val1 = Number(val1);
          val2 = Number(val2);
        }
        if (val1 < val2) {
          return -1;
        } else if (val1 > val2) {
          return 1;
        } else {
          return 0;
        }
      }
      );
      this.chartAll.chart = chartList;
      this.chartAll.elem = elemList;
      await this.getViewDpValue();
    },
    //图片加载失败 0 多维分析图表
    imgError(event, type) {
      if (type === 0) {
        let index = this.randomNum(1, 1).toFixed(0);
        $(event.target).attr('src', require(`./img/${index}.png`))
      }
    },
    //生成图表之前
    getDrag(type, ev, item, i) {

      if (type === 0) {
        this.dropVal.type = item.type;
        if (this.chart.type === 1) {
          this.dropVal.name = i.chartName;
          this.dropVal.viewChart = i;
        } else {
          this.dropVal.name = i.name;
          this.dropVal.viewChart = '';
        }
      } else if (type === 1) {
        if (this.chart.type === 0) {
          if (!this.dropVal.type && this.dropVal.name) {
            return
          }
        }
        let module = modules[this.dropVal.type];
        let op = module.option;
        this.$refs[`popover_${this.dropVal.type}`][0] && this.$refs[`popover_${this.dropVal.type}`][0].doClose();
        let FaPage = $('#configScreen_FCanvas');
        // if(!ev){return}
        let x = ev.pageX - (FaPage.offset().left - $("body").scrollLeft());
        let y = ev.pageY - (FaPage.offset().top - $("body").scrollTop());
        x = Math.round((x / this.slider.value * 100));
        y = Math.round((y / this.slider.value * 100));
        let elX = FaPage.width();
        let elY = FaPage.height();
        let itemW = op.dp_wight || 300;
        let itemH = op.dp_height || 200;
        if (x >= elX || (x + (itemW / 2)) >= elX) {
          x = elX - itemW;
        } else if (x <= (itemW / 2)) {
          x = 0;
        } else {
          x = x - (itemW / 2);
        }
        if (y >= elY || (y + (itemH / 2)) >= elY) {
          y = elY - itemH;
        } else if (y <= (itemH / 2)) {
          y = 0;
        } else {
          y = y - (itemH / 2);
        }
        this.vuex.chartList.map((item) => {
          item.active = false;
        });
        let data = {
          x: x,
          y: y,
          z: this.vuex.chartList.length + 1,
          backColor: this.getRGBColor(),
          chartType: this.chart.type,
        };
        //生成图表
        this.getOptionChart(data);
      }
    },
    //生成图表之时  加载数据
    async getOptionChart(data) {
      let option = optionChart(this.dropVal, data);
      await this.getSaveClearVueX();
      await this.getBasicCharts(JSON.parse(JSON.stringify(option)));
      let saveData = await this.$store.dispatch('screenSaveData');
      option.saveOption = saveData;
      this.vuex.chartList.push(option);
      await this.getRendBasicChart(option);
    },
    //基本图表 元素 多维分析 加载数据
    async getBasicCharts(option) {
      //子集数据
      let dataParam = {};
      modules[option.type].chilCharts.map((item) => {
        if (item.name === option.name) {
          dataParam = item;
        }
      });
      let charts = modules[option.type];
      //维度参数 默认
      let wdParamsNow = await charts.wdHandle(charts.option);
      let wdParams = await this.getDGCopy(wdParamsNow, dataParam.wdParam);
      //度量参数 默认
      let dlParamsNow = await charts.dlHandle(charts.option);
      let dlParams = await this.getDGCopy(dlParamsNow, dataParam.dlParam);
      //基本参数
      let paramsNow = await charts.params(charts.option);
      let params = await this.getDGCopy(paramsNow, dataParam.chartParam);
      //当前图表 公共配置项
      let comConfig = JSON.parse(JSON.stringify(this.defaultVal.comConfig));
      //当前图表
      this.chartVuex.type = option.type;
      this.chartVuex.name = option.name;
      this.chartVuex.id = option.id;
      this.chartVuex.domId = 'screen_dom_' + option.id;
      this.chartVuex.option = charts.option;
      this.chartVuex.trans = option.trans;
      this.chartVuex.dragType = option.dragType;
      //默认配置项
      this.nowChart.config.wdConfig = false;
      this.nowChart.config.dlConfig = false;
      this.nowChart.config.JSONConfig = false;
      this.nowChart.config.comConfig = false;
      this.nowChart.config.borderConfig = false;
      this.nowChart.config.chartsTimingTask = false;
      if (this.chartVuex.option.isWdConfig) {
        this.nowChart.config.wdConfig = true;
      }
      if (this.chartVuex.option.isDlConfig) {
        this.nowChart.config.dlConfig = true;
      }
      //判断是否是多维分析
      if (option.dragType !== 1) {
        this.nowChart.comPonent.wdParams = wdParams;
        this.nowChart.comPonent.dlParams = dlParams;
        this.chartVuex.setting.params = params;
        this.chartVuex.comConfig = comConfig;
        if (this.chartVuex.option.isJSONConfig) {
          this.nowChart.config.JSONConfig = true;
        }
      } else {
        let saveOption = option.saveOption;
        this.chartVuex.setting = saveOption.setting;
        this.chartVuex.comConfig = await this.getDGCopy(comConfig, saveOption.nowChart.comConfig);
        //维度
        for (let item of this.chartVuex.setting.wdList) {
          item.params = this.getDGCopy(wdParams, item.params);
        }
        //度量
        for (let item of this.chartVuex.setting.dlList) {
          item.params = this.getDGCopy(dlParams, item.params);
        }
        //默认参数
        this.chartVuex.setting.params = await this.getDGCopy(params, this.chartVuex.setting.params);
      }
      if (this.chartVuex.option.isComConfig) {
        this.nowChart.config.comConfig = true;
      }
      if (!this.chartVuex.option.isComBorder) {
        this.chartVuex.comConfig.border.show = false;
        this.nowChart.config.borderConfig = false;
      } else {
        this.nowChart.config.borderConfig = true;
      }
      //原始的结构
      this.chartVuex.initOrig = charts;

      charts.configModule.map((item) => {
        item.show = true;
      });
      let moduleList = charts.configModule;
      if (dataParam.isNoModuleName) {
        dataParam.isNoModuleName.map((item) => {
          moduleList.map((node, index) => {
            if (item === node.name) {
              node.show = false;
            }
          })
        });
      }

      //配置组件配置
      this.nowChart.comPonent.component = moduleList;
      this.nowChart.comPonent.wdComponent = charts.wdComponent;
      this.nowChart.comPonent.dlComponent = charts.dlComponent;
      this.nowChart.comPonent.jsonComponent = charts.JSONData.jsonPonent;
      //JSON
      if (this.chartVuex.option.isJSONConfig && option.dragType !== 1) {
        //JSON数据
        //公共配置的JSON对象
        this.nowChart.comParam.JSONData = JSON.parse(JSON.stringify(this.defaultVal.JSONData));
        this.nowChart.comParam.JSONData.valData = JSON.stringify(charts.JSONData.listDaVal, null, '  ');
        this.nowChart.comParam.JSONData.oldValData = JSON.stringify(charts.JSONData.listDaVal, null, '  ');
        this.nowChart.comParam.JSONData.params = JSON.parse(JSON.stringify(charts.JSONData.params));
        //修改用的JSON对象
        this.vuex.updParam.JSONData = JSON.parse(JSON.stringify(this.nowChart.comParam.JSONData));
      }


    },
    //基本图表 元素 多维分析 渲染
    async getRendBasicChart(option) {
      try {
        if (option.dragType !== 1) {
          if (this.chartVuex.option.isJSONConfig) {
            await this.$store.dispatch('screenValConvert');
          }
        } else {
          this.chartVuex.data = await getViewDpData(option.viewDP.viewId);
          for (let item of this.vuex.chartList) {
            if (item.id === option.id) {
              item.viewDP.returnData = this.chartVuex.data;
              break;
            }
          }
        }
        this.$nextTick(async () => {
          await this.$store.dispatch('screenRender');
        });
      } catch (e) {
        for (let item of this.vuex.chartList) {
          if (item.id === this.chartVuex.id) {
            item._isError = true;
          }
        }
      }
    },
    //维度弹框
    getWDDialog(type, item) {
      if (type === 0) {
        if (!this.nowChart.comPonent.wdComponent) {
          return;
        }
        this.dpWD.title = item.name;
        this.dpWD.index = 0;
        this.chartVuex.setting.wdList.map((node, nodeI) => {
          if (item.name === node.name) {
            this.dpWD.index = nodeI;
          }
        });
        this.dpWD.show = true;
      } else if (type === 1) {
        this.dpWD.show = false;
      }
    },
    //度量弹框
    getDLDialog(type, item) {
      if (type === 0) {
        if (!this.nowChart.comPonent.dlComponent) {
          return;
        }
        this.dpDL.title = item.name;
        this.dpDL.index = 0;
        this.chartVuex.setting.dlList.map((node, nodeI) => {
          if (item.name === node.name) {
            this.dpDL.index = nodeI;
          }
        });
        this.dpDL.show = true;
      } else if (type === 1) {
        this.dpDL.show = false;
      }
    },
    //图层弹框
    getTCDialog(type) {
      if (type === 0) {
        this.dpTC.show = true;
      } else if (type === 1) {
        this.dpTC.show = false;
      }
    },
    //随机生成颜色
    getRGBColor() {
      let r = this.randomNum(0, 255, 0);
      let g = this.randomNum(0, 255, 0);
      let b = this.randomNum(0, 255, 0);
      return 'rgba(' + r + ',' + g + ',' + b + ',0)'
    },
    //右侧配置切换
    getConfigType(type) {
      if (type === this.rigConfig.type) {
        return;
      }
      this.rigConfig.type = type;
    },
    //点击图表
    async getDragClick(option) {
      if (option.id === this.chartVuex.id) {
        return;
      }
      if (option.trans.isNoDrag) {
        await this.getSaveClearVueX();
        return;
      }
      await this.getSaveClearVueX();
      let charts = modules[option.type];
      await this.$store.dispatch('screenSwitchChart', { option, charts });
      if (option.dragType !== 1) {
        if (this.chartVuex.option.isJSONConfig) {
          await this.$store.dispatch('screenValConvert');
        }
      }
      let trans = option.trans;
    },
    // 点击图表2
    getDragClickIN() {

    },
    //保存当前图表并清空组件
    async getSaveClearVueX() {
      await this.$store.dispatch('screenSaveChart');
      await this.$store.dispatch('screenClear');
    },
    //拖拽图表
    async getDragResize(obj, item, i) {

      this.vuex.chartList[i].active = true;
      this.canvas.chartBorder = true;
      this.vuex.chartList[i].trans.x = obj[0].left;
      this.vuex.chartList[i].trans.y = obj[0].top;
      this.vuex.chartList[i].trans.width = obj[0].width;
      this.vuex.chartList[i].trans.height = obj[0].height;
      this.trans = this.vuex.chartList[i].trans;
    },
    //拖拽之后
    getDragOver(obj, item) {
      if (!item.component) {
        let dom = document.getElementById('screen_dom_' + item.id);
        let echart = echarts.init(dom);
        echart.resize();
      }
      this.dragBoxMove(1);
    },
    //拖动块 边框线
    dragBoxMove(type) {
      if (type === 0) {

      } else if (type === 1) {
        this.canvas.chartBorder = false;
        this.vuex.chartList.map((item, index) => {
          if (item.id === this.chartVuex.id) {
            this.vuex.chartList[index].active = true;
          }
        })
      }
    },
    //拖拽之后
    dragBoxStop() {
      this.dragBoxMove(1);
    },
    //取消所有选中
    async getNoCheckList() {
      for (let item of this.vuex.chartList) {
        item.active = false;
      }
      await this.getSaveClearVueX();
    },
    //保存数据之前 数据处理 data
    getSaveBefore() {
      let screenJson = JSON.stringify(this.nowChart.pageParam);
      let viewLocs = [];

      let chartList = JSON.parse(JSON.stringify(this.vuex.chartList));

      chartList.map(async (item) => {
        let returnData = JSON.stringify(item.viewDP.returnData);
        let saveOption = item.saveOption;
        let charts = modules[item.type];
        if (charts.saveParams) {
          let params = saveOption.setting.params;
          let saveParams = charts.saveParams(charts.option);
          params = await this.getDGCopy(params, saveParams);
        }
        item.viewDP.returnData = {};
        viewLocs.push({
          requestJson: JSON.stringify(item),
          webID: item.id,
          returnData: returnData
        })
      });
      let data = {
        screenPageName: this.rigConfig.dpName,
        groupID: this.viewScree.modeId,
        thumbNail: this.viewScree.pageImg,
        screenJson: screenJson,
        viewLocs: viewLocs,
        sizeX: this.vuex.pageSize.width,
        sizeY: this.vuex.pageSize.height,
        pageIndex: 0,
        //轮播方式:决定RotationID和OutLinkText哪个为空
        // rotationID: this.rotationID,// 要轮播的大屏ID
        // isRotation: this.checkedVal1,// 是否轮播0:否 1:是
        // rotationTime: this.rotationTime,// 轮播倒计时
        // isOutIn: this.isOutIn, //轮播属性0：内部 1：外部
        // outLinkText: this.outLinkText//外部链接
      };
      if (this.type === 'upd') {
        data.id = this.jkData.id;
      }
      // this.vuex
      return data;
    },
    //保存 接口
    async getSaveAfter() {
      let data = await this.getSaveBefore();
      SaveScreenPage(data).then(res => {
        if (res.code === 200) {
          this.getMsg('保存成功！', 'success');
          this.count = 0;
          if (this.type === 'upd') {
            localStorage.setItem('upd', '1')
            this.getRouterPath('/viewScreen')
          } else {
            this.setSession({
              'screen_viewDp_xy': res.data.dataTable.screensID
            });
            this.getRouterPath('/viewScreen')
          }
        }
      }).catch(() => {

      });
      setTimeout(() => {
        this.allLoad = false;
      }, 300)
    },
    //保存数据
    async getSave() {
      await this.getSaveClearVueX();
      if (this.rigConfig.dpName) {
        this.allLoad = true;
        if (await this.getdpNameRepeat()) {
          this.getPageImgSave();
        } else {
          setTimeout(() => {
            this.allLoad = false;
          }, 300)
        }
      } else {
        this.$prompt('大屏名称', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnPressEscape: false,
          closeOnClickModal: false,
          customClass: 'alert_allCom',
          beforeClose: async (action, instance, done) => {
            if (action === 'confirm') {
              if (!instance.inputValue) {
                this.getMsg('请输入大屏名称');
              } else {
                if (await this.getdpNameRepeat(instance.inputValue)) {
                  done();
                }
              }
              return false;
            } else {
              done();
            }
          }
        }).then(({ value }) => {
          this.allLoad = true;
          this.getPageImgSave();
        }).catch(() => {

        });
      }
    },
    //保存页面图片
    async getPageImgSave() {
      // this.viewScree.pageImg = '';
      // this.getSaveAfter();

      /*图片跨域及截图模糊处理*/
      html2canvas(document.querySelector("#configScreen_FCanvas"), { useCORS: true }).then(async canvas => {
        let baseData = canvas.toDataURL("image/jpeg", 1.0);
        let blob = this.dataURItoBlob(baseData);
        let form = new FormData();
        form.append("file", blob);
        await UploadPreviewPictureAsync(form).then(res => {
          if (res.code === 200) {
            this.viewScree.pageImg = res.data.webFilePath;
          }
        });
        this.getSaveAfter();
      }).catch(() => {
        this.getSaveAfter();
      });
    },
    //大屏名称重复校验
    async getdpNameRepeat(name) {
      if (this.type === 'upd') {
        if (this.jkData.screenPageName === this.rigConfig.dpName) {
          return true;
        }
      }
      let bool = false;
      if (name) {
        this.rigConfig.dpName = name;
      }
      await GetScreenPageNameVerify({
        groupID: this.viewScree.modeId,
        screenPageName: this.rigConfig.dpName,
      }).then(res => {
        if (res.code === 200) {
          bool = true;
        } else {

        }
      }).catch(() => {

      });
      return bool;
    },
    //获取canvas父级宽高
    getBodyCanvas() {
      this.$nextTick(() => {
        let width = $('#configScreen_FCanvas_body').width();
        let height = $('#configScreen_FCanvas_body').height();
        $('#configScreen_FCanvas_body').find('.el-scrollbar__view').css({
          'max-width': width,
          'max-height': height,
        })
      })
    },
    //滑块改变
    getCanvasResize() {
      if (this.slider.value < 30) {
        this.slider.value = 30;
      }
      $('#configScreen_FCanvas').css({
        'transform': 'scale(' + (this.slider.value / 100) + ') translate(0px, 0px)',
        'transform-origin': '0 0'
      });
      this.$refs.configScreenScrollbar && this.$refs.configScreenScrollbar.update();
    },
    //撤销 还原 type 0 撤销 1 还原
    async getUndo(type) {
      if (type === 0) {
        let list = [];
        if (this.undoNowIndex === 1) {
          return;
        }
        if ((this.listUndo.length - 2) >= 0) {
          list = this.listUndo[(this.undoNowIndex - 2)];
          let yesId = [];
          let listId = [];
          list.map((item) => {
            listId.push(item.id);
            yesId = [];
            for (let node of this.vuex.chartList) {
              if (item.id === node.id) {
                node.trans = item.trans;
                break;
              }
            }
          });
          yesId = this.vuex.chartList.map((node) => node.id);
          let noId = await this.listNoRepeat(yesId, listId);
          if (yesId.length > listId.length) {
            noId.map((item) => {
              let option = {};
              for (let node of this.vuex.chartList) {
                if (item === node.id) {
                  option = JSON.parse(JSON.stringify(item));
                  break;
                }
              }
              let i = this.vuex.chartList.length;
              while (i--) {
                if (this.vuex.chartList[i].id === item) {
                  this.vuex.chartList.splice(i, 1);
                }
              }
              this.updProcessList.push({
                index: this.updProcessList,
                type: 'del',
                item: option
              })
            });
          } else if (yesId.length < listId.length) {
            noId.map((item) => {
              let option = {};
              for (let node of this.vuex.chartList) {
                if (item === node.id) {
                  option = JSON.parse(JSON.stringify(item));
                  break;
                }
              }
              this.updProcessList.push({
                index: this.updProcessList,
                type: 'add',
                item: option
              })
            });
          }


          this.undoNowIndex--;
        }
      } else if (type === 1) {
        let list = [];
        if (this.undoNowIndex === this.listUndo.length) {
          return;
        }
        if ((this.listUndo.length - 2) >= 0) {
          list = this.listUndo[this.undoNowIndex];
          let yesNode = [];
          list.map((item) => {
            for (let node of this.vuex.chartList) {
              if (item.id === node.id) {
                yesNode.push(node.id);
                node.trans = item.trans;
                break;
              }
            }
          })
          this.undoNowIndex++;
        }
      }
    },
    //保存撤销还原数组
    getUndoSaveList() {
      let transList = [];
      this.vuex.chartList.map((item) => {
        transList.push({
          id: item.id,
          trans: JSON.parse(JSON.stringify(item.trans))
        })
      });
      this.listUndo.push(transList);
      this.undoNowIndex++;
    },

    // - - - - - - - - - - - - -  删除 复制 锁定

    //删除
    async getLayerRemove() {
      this.$refs.dragLayerRef && this.$refs.dragLayerRef.removeChart();
    },
    //复制
    async getLayerCopy() {
      this.$refs.dragLayerRef && this.$refs.dragLayerRef.copyChart();
    },
    //锁定
    async getLayerLock() {
      this.$refs.dragLayerRef && this.$refs.dragLayerRef.lockingChart();
    },

    getTest() {
    },

    //图片显示失败
    errorImg(img) {
      this.src = img
    },
    //封装blob对象
    dataURItoBlob(baseData) {
      let byteString;
      if (baseData.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(baseData.split(',')[1]);
      else
        byteString = unescape(baseData.split(',')[1]);
      let mimeString = baseData.split(',')[0].split(':')[1].split(';')[0];
      let ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    },
  },
  created() {
    window.xz = this.xz;
    window.sz = this.sz;
  },
  computed: {
    //vuex
    vuex() {
      return this.$store.state.designer;
    },
    //当前图表的参数
    chartVuex() {
      return this.$store.state.designer.chart;
    },
    //公共的参数
    nowChart() {
      return this.$store.state.designer.nowChart;
    },
    //默认的参数
    defaultVal() {
      return this.$store.state.designer.defaultVal;
    },
    //背景
    backParam() {
      return this.$store.state.designer.nowChart.pageParam.back;
    },
    dragOptions() {
      return {
        animation: 300,
        group: "description",
        disabled: this.inp.id ? true : false,
      };
    },
    chartList: {
      get() {
        let data = [];
        this.$store.state.designer.chartList.map((item, index) => {
          data.push({
            name: (item.aliasName || item.name || '--'),
            id: item.id,
            isNoDrag: item.trans.isNoDrag,
            index: item.trans.z,
            check: false,
          })
        });
        data.sort((obj1, obj2) => {
          let val1 = obj1['index'];
          let val2 = obj2['index'];
          if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
            val1 = Number(val1);
            val2 = Number(val2);
          }
          if (val1 < val2) {
            return -1;
          } else if (val1 > val2) {
            return 1;
          } else {
            return 0;
          }
        }
        );
        return data;
      },
      set(data) {
        data.sort(this.sortChart);
        data.map((node, index) => {
          for (let item of this.$store.state.designer.chartList) {
            if (node.id === item.id) {
              item.trans.z = (index + 1);
              item.trans.isNoDrag = node.isNoDrag;
              item.aliasName = node.name;
              break;
            }
          }
        });
        return data;
      }
    },
    showList: {
      get() {
        let list = JSON.parse(JSON.stringify(this.chartList));
        return list.reverse();
      },
      set(data) {
        let list = JSON.parse(JSON.stringify(data));
        this.chartList = list.reverse();
        return data;
      }
    },
    NewDeviceList() {
      // 新的赋值
      return JSON.parse(JSON.stringify(this.clearfieldArr));
    }
  },
  watch: {
    DelList: function (newValue, oldValue) {
      this.newData = []
      var a = []
      for (var i = 0; i < this.DelList.length; i++) {
        a.push(this.DelList[i])
      }
      for (var i = 0; i < this.data.length; i++) {
        var b = []
        for (var j = 0; j < this.data[i].children.length; j++) {
          b.push(this.data[i].children[j].label)
        }
        if (a.every(element => b.includes(element)) && a.length > 0) {
          this.newData.push(this.data[i])
          var Data = document.getElementById("Data");
          var newData = document.getElementById("newData");
          Data.style.display = "none"
          newData.style.display = "block"
        } else if (a.length == 0) {
          this.newData = []
          var Data = document.getElementById("Data");
          var newData = document.getElementById("newData");
          Data.style.display = "block"
          newData.style.display = "none"
        } else {
          var Data = document.getElementById("Data");
          var newData = document.getElementById("newData");
          Data.style.display = "none"
          newData.style.display = "block"
        }
      }
    },
    filterText1(val) {
      this.$refs.tree1.filter(val);
    },
    filterText2(val) {
      this.$refs.tree2.filter(val);
    },
    NewDeviceList() {
      for (let i in this.clearfieldArr[this.clearfieldArr.length - 1]) {
        if (!this.clearfieldArr[this.clearfieldArr.length - 1][i]) {
          this.save = false;
          return;
        } else {
          this.save = true;
        }
      }
    }
  },
  mounted() {
    this.init();

  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      //设计器
      vm.$store.state.dpType = 1;
    });
  },
  beforeRouteLeave(to, from, next) {
    let count = 0;
    for (let i in setConfigAll.routePath) {
      if (i === '综合展现') {
        setConfigAll.routePath[i].map((item) => {
          if (item.path === to.path) {
            count = 1;
          }
        })
      }
    }
    if (count !== 0) {
      if (this.count !== 0) {
        if (this.vuex.chartList.length) {
          this.$alert('你确定要离开当前页面吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            showCancelButton: true,
            closeOnPressEscape: false,
            closeOnClickModal: false,
            customClass: 'alert_allCom',
          }).then(() => {
            next();
          }).catch(() => {
            next(false);
          });
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      next();
    }
  },
  async beforeDestroy() {
  }
}
</script>

<style lang="less">
@borderRadio: 5px;
@borderColor: #ccc;
@shadow: 0 0 15px @h_top_backColor;
@conBackWLS: #eaeaea;
@cenMargin: 15px;
@minMargin: 20px;
@saveHeight: 80px;
@dp_fontColor: #fff;
//图表弹出框
@pop_back: #272936;
@pop_bor: hsl(@green, 50%);

.linkage {
  min-height: 588px;
  max-height: 850px;
  background: #fff;
  overflow-y: scroll;

  .tit {
    font-size: 22px;
    line-height: 22px;
    height: 22px;
    margin-bottom: 15px;

    span {
      float: right;
      color: #2082ff;
    }
  }

  .content {
    height: 272px;
    border-radius: 10px;

    .echarts {
      width: 50%;
      height: 100%;
      float: left;
      background: #eaebf7;
      border-radius: 10px 0 0 10px;

      ul {
        height: 250px;
        width: 100%;
        margin-top: 10px;
        overflow-y: scroll;
        overflow-x: hidden;

        li {
          height: 36px;
          line-height: 36px;
          background: #eaebf7;
          padding-left: 20px;
          border-radius: 5px;
          transition: background-color 0.3s linear;

          span {
            width: 100%;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
          }
        }

        li:hover {
          background: #fff;
        }

        .whiteBg {
          background: #fff;
        }
      }

      ul::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      /*定义滚动条轨道 内阴影+圆角*/
      ul::-webkit-scrollbar-track {
        border-radius: 10px;
      }

      /*定义滑块 内阴影+圆角*/
      ul::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d2d2d2;
      }
    }

    .fields {
      width: 50%;
      height: 100%;
      background: #eeeeee;
      float: left;
      border-radius: 0 10px 10px 0;

      ul {
        height: 250px;
        width: 100%;
        margin-top: 10px;
        overflow-y: scroll;
        overflow-x: hidden;

        li {
          height: 36px;
          line-height: 36px;
          background: #eeeeee;
          padding-left: 20px;
          border-radius: 5px;
          transition: background-color 0.3s linear;
        }

        .whiteBg {
          background: #fff;
        }

        li:hover {
          background: #fff;
        }
      }

      ul::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      /*定义滚动条轨道 内阴影+圆角*/
      ul::-webkit-scrollbar-track {
        border-radius: 10px;
      }

      /*定义滑块 内阴影+圆角*/
      ul::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #d2d2d2;
      }
    }
  }

  .left {
    width: 360px;
    height: 310px;
    float: left;
  }

  .right {
    width: 360px;
    height: 310px;
    float: right;
  }

  .bottom {
    width: 100%;
    min-height: 158px;
    margin-top: 30px;
    float: left;

    .judge {
      margin-bottom: 10px;
      width: 100%;

      input:nth-child(3) {
        margin-left: 130px;
      }

      input:nth-child(4) {
        margin-right: 0;
      }

      input {
        width: 122px;
        height: 28px;
        // border-radius: 10px;
        text-align: center;
        margin-right: 40px;
        outline: none;
        border: 1px solid #e5e5e5;
      }

      input:focus {
        box-shadow: 0 0 10px 0 skyblue;
      }

      .circleBtn {
        width: 50px;
        height: 28px;
        display: inline-block;
        vertical-align: middle;
        float: right;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .circleAdd,
      .circleDel {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        text-align: center;
        line-height: 11px;
        font-size: 18px;
        font-weight: bold;
        cursor: pointer;
      }

      .circleAdd:active {
        border-color: rgba(0, 206, 83, 0.5);
        color: rgba(0, 206, 83, 0.5);
      }

      .circleAdd {
        border: 2px solid #00ce53;
        color: #00ce53;
      }

      .circleDel:active {
        border-color: rgba(255, 18, 64, 0.5);
        color: rgba(255, 18, 64, 0.5);
      }

      .circleDel {
        border: 2px solid #ff1240;
        color: #ff1240;
      }
    }

    .bottom_tit {
      width: 100%;
      height: 22px;
    }

    .leftList {
      width: 360px;
      float: left;
    }

    .rightList {
      width: 360px;
      float: right;
    }

    .btn {
      float: right;
      margin-top: 70px;

      .el-button:nth-child(1) {
        background: #39ae78;
        color: #fff;
        border: none;
      }

      .el-button.is-disabled,
      .el-button.is-disabled:hover,
      .el-button.is-disabled:focus {
        border: none;
        background: #999;
        color: #fff;
      }
    }
  }
}

.linkage::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/*定义滚动条轨道 内阴影+圆角*/
.linkage::-webkit-scrollbar-track {
  border-radius: 10px;
}

/*定义滑块 内阴影+圆角*/
.linkage::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d2d2d2;
}

.configScreen {
  width: 100%;
  height: 100%;
  padding: 20px;

  .configMain {
    width: 100%;
    height: 100%;
    background: #eaebf7;
    padding: 20px;

    .leftScreen {
      height: 100%;
      border-radius: 5px;
      display: inline-block;
      float: left;
      width: 11%;
      margin-right: 1%;
      .checkCharts {
        background-color: #fff;
        border-radius: 5px;
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        box-shadow: 0 0 10px @h_top_backColor;
        color: @dp_fontColor;
        letter-spacing: 3px;
        line-height: 50px;
        height: 50px;
        text-align: center;
        margin-bottom: 20px;
        .el-select {
          width: 100%;
          height: 100%;

          :focus {
            outline: -webkit-focus-ring-color auto 0;
          }

          .el-input__inner {
            background-color: transparent;
            border: 0;
            height: 50px;
            line-height: 50px;
            color: #000;
            // color: #000;
            font-size: 16px;
            letter-spacing: 3px;
          }

          .el-input__icon {
            line-height: 50px;
            color: #000;
            // color: #000;
            font-size: 14px;
          }

          .el-select-dropdown {
            margin-top: 3px !important;
            // background-color: hsl(@h_top_backColor, 1);
            background-color: #fff;
            // border: 1px solid rgba(19, 181, 177, 0.6);
            -webkit-box-shadow: #c1cff7 0px 0px 15px;
            -moz-box-shadow: #c1cff7 0px 0px 15px;
            box-shadow: #c1cff7 0px 0px 15px;

            ul {
              li {
                // color: @dp_fontColor;
                color: #000;
                padding: 0;
                margin-bottom: 5px;

                .selOption {
                  width: 100%;
                  height: 100%;
                  padding: 0 20px;

                  .opIcon {
                    width: 17px;
                    height: 17px;
                    margin-right: 15px;
                    float: left;
                    display: inline-block;
                    .com_middle;

                    > svg {
                      display: inherit;

                      path {
                        fill: #000;
                        // fill: #000;
                      }
                    }
                  }

                  span {
                    width: calc(100% - 17px - 15px);
                    height: 100%;
                    display: inline-block;
                    color: #000;
                    // color: #000;
                    letter-spacing: 3px;
                    text-align: left;
                    .text_oneLine;
                  }
                }
              }

              .selected {
                background: #002774;

                path {
                  fill: #fff !important;
                }

                span {
                  // color: @green !important;
                  color: #fff !important;
                }
              }

              .hover {
                background-color: #002774;

                path {
                  fill: #fff !important;
                }

                span {
                  color: #fff !important;
                }
              }
            }

            .popper__arrow {
              display: none;
            }
          }
        }
      }

      .leftCount {
        border: 1px solid @h_top_backColor;
        border-radius: 5px;
        // background-color: #0a122e;
        box-shadow: 0 0 10px @h_top_backColor;

        .el-scrollbar {
          width: 100%;
          height: 100%;
          background-color: #fff;
        }

        .el-scrollbar__wrap {
          overflow-x: hidden;
        }

        .chartUl {
          width: 100%;
          height: 100%;
          overflow: auto;
          display: inline-block;
          padding: 0 10px;

          :focus {
            outline: -webkit-focus-ring-color auto 0;
          }

          .chart_d {
            width: 100%;
            margin: 10px 0;
            // border-radius: 5px;
            padding: 5px;
            position: relative;
            cursor: pointer;
            border: 1px dashed rgba(0, 0, 0, 0);

            .drageDiv {
              position: absolute;
              width: 100%;
              height: 100%;
              border-radius: 5px;
              top: 0;
              left: 0;
              z-index: 2;
            }

            .imgDiv {
              width: 100%;
              display: inline-block;
              text-align: center;

              > img {
                width: 70%;
              }
            }

            > span {
              .text_oneLine;
              // color: #13b3af;
              color: #000;
              letter-spacing: 1px;
              font-size: 16px;
              width: 100%;
              line-height: 1;
              display: inline-block;
              text-align: center;
            }
          }

          .chart_d:hover {
            // border: 1px dashed @green;
            // border-radius: @borderRadio;
            // background-color: hsl(@green, 13%);
            -webkit-box-shadow: #c1cff7 0px 0px 15px;
            -moz-box-shadow: #c1cff7 0px 0px 15px;
            box-shadow: #c1cff7 0px 0px 15px;
          }
        }
      }
    }

    .centCanvas {
      height: 100%;
      border-radius: 5px;
      display: inline-block;
      position: relative;
      margin-right: 1%;
      float: left;
      width: 70%;

      .conCanvas {
        width: 100%;
        height: 50px;
        margin-bottom: 20px;
        border-radius: 5px;
        background-color: #002774;
        line-height: 40px;
        padding: 5px 12px;
        box-shadow: 0 0 10px @h_top_backColor;

        .FBtn {
          > div {
            display: inline-block;
          }
        }

        .conCanvasTop_btn {
          border: 1px solid @green;
          border-radius: 4px;
          width: 50px;
          height: 35px;
          text-align: center;
          cursor: pointer;
          line-height: 35px;
          opacity: 0.7;
          position: relative;
          top: 50%;
          transform: translateY(-50%);
          float: left;
          margin-right: 8px;

          .divBtn {
            display: inline-block;
            width: 25px;
            height: 25px;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
          }

          //图层
          .layer_btn {
            background: url("./img/layer.png");
            background-size: 100% 100%;
          }

          //删除
          .del_btn {
            background: url("./img/del.png");
            background-size: 100% 100%;
          }

          //复制
          .copy_btn {
            background: url("./img/copy.png");
            background-size: 100% 100%;
          }

          //锁定
          .lock_btn {
            background: url("./img/lock.png");
            background-size: 100% 100%;
          }
        }

        .conCanvasTop_btn:hover {
          opacity: 1;
        }
      }

      .FCanvas {
        height: 100%;
        width: 100%;
        border-radius: 5px;
        border: 1px solid @h_top_backColor;
        box-shadow: 0 0 10px @h_top_backColor;
        background-color: #0a122e;
        position: relative;
        padding: 16px;

        .rulerX {
          position: absolute;
          width: 100%;
          height: 13px;
          top: 0;
          left: 0;
          white-space: nowrap;
          overflow: hidden;
          padding-left: 10px;

          .bigRul {
            height: 13px;
          }

          > div {
            width: 10px;
            height: 8px;
            float: left;
            display: inline-block;
            border-right: 1px solid #a8b6e5;
          }
        }

        .rulerY {
          position: absolute;
          height: 100%;
          width: 13px;
          top: 0;
          left: 0;
          overflow: hidden;
          padding-top: 10px;

          .bigRul {
            width: 13px;
          }

          > div {
            width: 8px;
            height: 10px;
            float: left;
            display: inline-block;
            border-bottom: 1px solid #a8b6e5;
          }
        }

        #configScreen_FCanvas_body {
          width: 100%;
          height: 100%;
          display: inline-block;
          position: relative;
          border: 1px solid #547487;

          border-radius: 5px;
          overflow: auto;

          .el-scrollbar {
            width: 100%;
            height: 100%;

            .el-scrollbar__wrap {
              overflow-x: hidden;
            }

            .el-scrollbar__view {
            }
          }

          .FCanvas_Page {
            .FCharsDrog {
              z-index: 0;
              font-size: 20px;
              text-align: center;
              color: #fff;
              overflow: hidden;
            }

            .linBorTop {
              border-top: 1px dashed #fff;
            }

            .linBorLeft {
              border-left: 1px dashed #fff;
            }

            .chart-xy-barder-top {
              width: 100%;
              .linBorTop;
            }

            .chart-xy-barder-bottom {
              width: 100%;
              .linBorTop;
            }

            .chart-xy-barder-left {
              height: 100%;
              .linBorLeft;
            }

            .chart-xy-barder-right {
              height: 100%;
              .linBorLeft;
            }

            // .FCharsDrog:hover {
            //   outline: 1px dashed hsl(@orange, 0.7);
            //   cursor: pointer;
            //   position: relative;
            // }
          }

          .chart-barder {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 999;
          }
        }
      }

      .centCanvas_block {
        position: absolute;
        bottom: 4%;
        right: 3%;
        width: 15%;
      }
    }

    .rightCanvas {
      border-radius: 5px;
      background-color: #fff;
      height: 100%;
      float: left;
      display: inline-block;
      width: 17%;

      .tbld {
        background: #eaebf7;
        width: 100%;
        padding-bottom: 10px;

        .FBtn {
          margin: 0 auto;
        }
      }

      .ConfigFrom {
        width: 100%;
        height: calc(100% - 50px);
        box-shadow: 0 0 10px @h_top_backColor;

        .tilConfig {
          width: 100%;
          height: 50px;
          line-height: 48px;
          // border: 1px solid rgba(19, 181, 177, 0.6);
          border-top-left-radius: 5px;
          border-top-right-radius: 5px;
          box-shadow: 0 0 10px @h_top_backColor;

          > span {
            display: inline-block;
            width: 50%;
            height: 48px;
            float: left;
            // color: @green;
            color: #000;
            text-align: center;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 3px;
            // border-right: 1px solid @green;
            cursor: pointer;
            .text_oneLine;
          }

          > span:first-child {
            border-top-left-radius: 5px;
          }

          > span:last-child {
            border-right: 0;
            border-top-right-radius: 5px;
          }

          > span:hover {
            background-color: rgba(0, 39, 116, 0.25);
          }

          .tilConfAdd {
            // background-color: rgba(19, 181, 177, 0.82) !important;
            border-bottom: 2px solid #002774;
            color: #002774;
          }
        }

        .countConfig {
          width: 100%;
          height: calc(100% - 30px);
          // height: 100%;

          .config_div {
            width: 100%;
            height: calc(100% - @saveHeight);
            border-bottom: 1px dashed @borderColor;
          }

          .config_div_left {
            .conLef_top {
              width: 100%;
              height: 100%;
              padding: 10px 0 0 0;

              .el-scrollbar {
                width: 100%;
                height: 100%;

                .el-scrollbar__wrap {
                  overflow-x: hidden;
                }

                .is-horizontal {
                  display: none;
                }

                .el-scrollbar__view {
                  padding: 0;
                  width: 100%;
                  height: 100%;
                  display: inline-block;

                  :focus {
                    outline: -webkit-focus-ring-color auto 0;
                  }

                  .configFlot {
                    padding-top: 10px;

                    .el-input__inner {
                      background-color: transparent !important;
                      color: #666 !important;
                      letter-spacing: 1px !important;
                    }

                    .comDP_config {
                      width: 100%;
                      padding: 0 10px;
                      margin-bottom: 10px;

                      .config_comTop {
                        width: 100%;
                        margin-bottom: 10px;

                        > span {
                          font-size: 14px;
                          color: #000;
                          width: 100%;
                          line-height: 20px;
                          letter-spacing: 2px;
                          font-weight: bold;
                          margin-bottom: 5px;
                          .text_oneLine;
                          display: inline-block;
                          margin-left: 2px;
                        }

                        .btSpan:after {
                          content: "*";
                          margin-left: 2px;
                          color: @red;
                        }

                        .el-input__inner {
                          height: 30px;
                          line-height: 30px;
                          padding: 0 7px;
                          letter-spacing: 1px;
                        }
                      }

                      .config_comTop:last-child {
                        margin-bottom: 0;
                      }
                    }
                  }
                }
              }
            }

            .conLef_bom {
              height: 80px;
              padding: 10px 10px;
              width: 100%;
              border-top: 1px dashed @borderColor;

              p {
                line-height: 30px;
                font-size: 14px;
                white-space: nowrap;
                letter-spacing: 2px;
                color: @fontColor;
                .text_oneLine;

                span {
                  color: @green;
                  margin: 0 5px;
                  display: inline-block;
                }
              }
            }

            .folt_chil_div {
              margin-top: 10px;

              .div_til {
                width: 100%;
                line-height: 35px;
                // background-color: hsl(@green, 0.4);
                background-color: rgba(0, 39, 116, 0.25);
                color: #000;
                padding: 0 10px;
                font-size: 14px;
                letter-spacing: 2px;
                font-weight: bold;
              }
            }

            .folt_chil_div:last-child {
              margin-bottom: 10px;
            }
          }

          .config_div_rig {
            .config_div_rig_div {
              width: 100%;
              height: 100%;
              overflow: auto;
              overflow-x: hidden;

              .configFlot {
                width: 100%;
                height: 100%;
                padding: 10px 0;

                .comDP_config {
                  width: 100%;
                  padding: 0 10px;
                  margin-bottom: 10px;

                  .config_comTop {
                    width: 100%;
                    margin-bottom: 10px;

                    > span {
                      font-size: 14px;
                      color: @fontColor;
                      width: 100%;
                      line-height: 20px;
                      letter-spacing: 2px;
                      font-weight: bold;
                      margin-bottom: 5px;
                      .text_oneLine;
                      display: inline-block;
                      margin-left: 2px;
                    }

                    .btSpan:after {
                      content: "*";
                      margin-left: 2px;
                      color: @red;
                    }

                    .el-input__inner {
                      height: 30px;
                      line-height: 30px;
                      padding: 0 7px;
                      letter-spacing: 1px;
                    }
                  }

                  .config_comTop:last-child {
                    margin-bottom: 0;
                  }
                }
              }
            }

            .config_div_rig_div::-webkit-scrollbar {
              width: 4px;
              height: 4px;
            }

            /*定义滚动条轨道 内阴影+圆角*/
            .config_div_rig_div::-webkit-scrollbar-track {
              border-radius: 10px;
            }

            /*定义滑块 内阴影+圆角*/
            .config_div_rig_div::-webkit-scrollbar-thumb {
              border-radius: 10px;
              background-color: #d2d2d2;
            }
          }

          .FFoldBox,
          .FFoldBox {
            border: 0 !important;

            .FFoldBox__header {
              background-color: hsl(@green, 0.4);
              color: @dp_fontColor;
              line-height: 35px;
              padding: 0 10px;
              font-size: 14px;
              letter-spacing: 2px;
              font-weight: bold;
              border: 0 !important;
              height: 35px;
              margin: 5px 0 0;
            }

            .FFoldBox__wrap {
              border: 0 !important;
              background-color: transparent !important;
            }

            .el-icon-arrow-right:before {
              color: @dp_fontColor;
            }

            .FFoldBox__content {
              padding: 0;
              color: @dp_fontColor;
              background-color: transparent;
            }

            .wdl_ri_div {
              height: 90px;
              border: 1px solid #006688;
              border-radius: 2px;
              margin: 5px;
              margin-top: 10px;
              margin-bottom: 10px;
              width: calc(100% - 10px);
              padding: 7px;

              > div {
                display: inline-block;
                padding: 0 7px;
                letter-spacing: 1px;
                background-color: rgba(0, 184, 63, 0.7);
                border-radius: 3px;
                line-height: 25px;
                font-size: 12px;
                margin-right: 5px;
                margin-bottom: 5px;
                color: #fff;
                cursor: pointer;
              }

              > div:hover {
                background-color: rgba(0, 184, 63, 1);
              }
            }
          }

          .save_div {
            width: 100%;
            height: @saveHeight;
            line-height: 65px;
            text-align: center;
            padding: 0 10px;
            display: inline-block;

            > .FBtn {
              width: 100%;

              > div {
                height: 40px;

                span {
                  float: none;
                  height: 40px;
                  line-height: 40px;
                  font-size: 18px;
                  letter-spacing: 5px;
                }
              }
            }
          }
        }
      }
    }
  }

  .screen_wd_dialog {
    .dialog_count {
      display: inline-block;
      width: 100%;
    }
  }

  .screen_dl_dialog {
    .dialog_count {
      display: inline-block;
      width: 100%;
    }
  }

  .screen_tc_dialog {
  }
}

.configScreen_pop_chart_chil {
  max-width: 420px;
  padding: 10px;
  // background-color: @pop_back;
  // border-color: @pop_bor !important;

  .scrollBar_xy {
  }

  .chart_chil {
    width: calc(100% + 10px);
    height: 100%;
    display: inline-block;
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 10px 0 10px 15px;

    .drageDiv {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 5px;
      top: 0;
      left: 0;
      z-index: 2;
    }

    .chart_d {
      width: 120px;
      height: 115px;
      margin-right: 5px;
      padding: 5px 5px 0;
      float: left;
      cursor: pointer;
      position: relative;
      border: 1px dashed transparent;

      > img {
        width: 108px;
        max-height: 80px;
      }

      > span {
        text-align: center;
        display: inline-block;
        line-height: 20px;
        font-size: 12px;
        letter-spacing: 2px;
        width: 100%;
        // color: @dp_fontColor;
        color: #000;
        .text_oneLine;
      }
    }

    .chart_d:hover {
      // border: 1px dashed @green;
      // border-radius: @borderRadio;
      // background-color: hsl(@green, 13%);
      -webkit-box-shadow: #c1cff7 0px 0px 15px;
      -moz-box-shadow: #c1cff7 0px 0px 15px;
      box-shadow: #c1cff7 0px 0px 15px;
    }
  }

  .chart_chil::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  .chart_chil::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /*定义滑块 内阴影+圆角*/
  .chart_chil::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }

  .popper__arrow {
    left: -7px !important;
    // border-right-color: @pop_bor !important;
    border-right-color: #fff !important;
  }

  .popper__arrow::after {
    // border-right-color: @pop_back !important;
    border-right-color: #fff !important;
  }
}

.chuanda {
  background-color: #fbfbfb;
  height: 588px;

  .left {
    height: 508px;
    float: left;
    width: 230px;
    background-color: #fbfbfb;
    padding: 10px;

    ul {
      margin-top: 10px;

      li {
        font-size: 16px;
        letter-spacing: 1px;
        padding-left: 20px;
        border-left: 4px solid #999;
        margin: 11px 0;
        float: left;
        width: 100%;
        img {
          vertical-align: -2px;
          float: right;
          margin-right: 7px;
        }
      }
    }
  }
  #Data {
    display: block;
  }
  #newData {
    display: none;
  }

  .center {
    height: 488px;
    float: left;
    width: 320px;
    margin-top: 10px;
    padding: 0 20px;
    background-color: #fff;
    border-radius: 10px 0 0 10px;
    overflow-y: scroll;

    .el-input {
      margin-bottom: 20px;
    }
  }
  // .center {
  //   height: 570px !important;
  //   overflow-y: scroll;
  //   overflow-x: hidden;
  //   background-color: #f5f5f5;
  // }
  .center::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  /*定义滚动条轨道 内阴影+圆角*/
  .center::-webkit-scrollbar-track {
    border-radius: 10px;
  }

  /*定义滑块 内阴影+圆角*/
  .center::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #d2d2d2;
  }

  .right {
    height: 488px;
    float: left;
    width: 258px;
    margin-top: 10px;
    padding: 0 20px;
    background-color: #fff;
    border-radius: 0 10px 10px 0;
    padding-top: 5px;

    .el-select {
      margin: 20px 0 30px 0;
    }
  }

  .bottom {
    width: 100%;
    height: 80px;
    background: #fff;
    float: left;
    padding: 20px 0;

    .el-button {
      float: right;
      margin-left: 20px;
    }
  }

  .tit {
    font-size: 18px;
    line-height: 30px;
    height: 30px;
    letter-spacing: 2px;

    img {
      vertical-align: -2px;
      margin-left: 100px;
    }
  }
}
.el-scrollbar__wrap {
  margin-right: 0 !important;
}
</style>
